import { render } from "./StaffAssistantWidget.vue?vue&type=template&id=ca70f4be&scoped=true&ts=true"
import script from "./StaffAssistantWidget.vue?vue&type=script&lang=ts"
export * from "./StaffAssistantWidget.vue?vue&type=script&lang=ts"

import "./StaffAssistantWidget.vue?vue&type=style&index=0&id=ca70f4be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca70f4be"]])

export default __exports__